import type { CredentialApiRouteName } from '@/shared/common/types/credentialApiRoutes.type';

export const CREDENTIAL_API_ROUTE_NAMES = {
  MAIN: 'api-credentials',
} as const;

export const CREDENTIAL_API_ROUTE_PATHS = {
  [CREDENTIAL_API_ROUTE_NAMES.MAIN]: '/api-credentials',
} as const satisfies Record<CredentialApiRouteName, string>;
